<template>
    <div class="com1" :class="{'bor':bor===true}">
        <div>
            我是组件1
        </div>
        <div class="closeIcon icon">x</div>
    </div>
</template>
<script>
export default {
    name: 'comOne',
    props: {
        bor: {
            type: Boolean,
            default: false
        }
    }
}
</script>
<style lang="scss" scoped>
    .com1{
        height: 50px;
        background: red;
        color: #fff;
        position: relative;
        .closeIcon{
            position: absolute;
            right: 0;
            top: 0;
            margin-top: -7px;
            margin-right: -7px;
            color: #fff;
            width: 15px;
            height: 15px;
            border-radius: 50%;
            background: #409EFF;
            color: #fff;
            line-height: 15px;
            font-size: 12px;
            text-align: center;
            box-sizing: border-box;
            cursor: pointer;
        }
        .icon:hover{
            background: #000;
        }
    }
    .bor{
        border: 2px solid green;
    }
</style>